import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { siteProvideCssService } from './siteProvideCssService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteProvideCssService)
}

export const editor: ContainerModuleLoader = site
